import { Button } from '@any-ui-react/core';
import { useFormContext, useWatch } from 'react-hook-form';

import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { useEmployeeAccess } from '@/common/hooks/employees/useEmployeeAccess';
import type { EmployeeDependentType, EmployeePersonalInformationFormDataType } from '@/common/types';

import { DependentModal } from './DependentModal';
import { DependentTable } from './DependentTable';

interface DependentProps {
  onCreate: (data: EmployeeDependentType) => void;
  onUpdate: (data: EmployeeDependentType) => void;
  onRemove: (id: string) => void;
}

export const Dependent = ({ onCreate, onUpdate, onRemove }: DependentProps) => {
  const {
    formState: { errors },
    control,
  } = useFormContext<EmployeePersonalInformationFormDataType>();
  const dependents = useWatch({ control, name: 'dependents' });

  const { employeeDetail } = useEmployeeDetailContext();
  const isNewRecord = !employeeDetail.id;
  const { hasEmployeePersonalInformationEditAccess } = useEmployeeAccess();
  const isEditable = hasEmployeePersonalInformationEditAccess || isNewRecord;

  return (
    <div className="mb-6">
      <div className="mb-4 flex gap-2 items-center justify-between">
        <h1 className="font-semibold">Dependents</h1>
        {isEditable && (
          <DependentModal isNewRecord={true} onSuccess={onCreate}>
            <Button variant="default">Add Dependent</Button>
          </DependentModal>
        )}
      </div>
      <DependentTable
        isEditable={isEditable}
        items={dependents}
        loading={false}
        onRemove={onRemove}
        onUpdate={onUpdate}
      />
      {errors.dependents && <span className="text-xs text-red-6">{errors.dependents.message}</span>}
    </div>
  );
};
